module.exports = __webpack_public_path__ + "static/media/arrows-v.e584ec42.svg";